import { jsxs as o, jsx as l } from "react/jsx-runtime";
const c = (a) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ...a,
    children: [
      /* @__PURE__ */ o("g", { clipPath: "url(#outlook-colored_svg__a)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#0A2767",
            d: "M28 16.72a.54.54 0 0 0-.256-.46h-.003l-.01-.005-8.316-4.923a1.116 1.116 0 0 0-1.247 0l-8.316 4.923-.01.005a.542.542 0 0 0 .013.929l8.316 4.922q.054.037.112.067a1.12 1.12 0 0 0 1.135-.067l8.316-4.922A.54.54 0 0 0 28 16.72"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#0364B8",
            d: "M10.822 13.434h5.457v5.003h-5.457zm16.062-5.085V6.06A1.037 1.037 0 0 0 25.872 5H11.71a1.037 1.037 0 0 0-1.012 1.06V8.35l8.372 2.232z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#0078D4", d: "M10.698 8.349h5.581v5.023h-5.581z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#28A8EA",
            d: "M21.86 8.349h-5.58v5.023l5.58 5.023h5.024v-5.023z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#0078D4", d: "M16.28 13.372h5.58v5.023h-5.58z" }),
        /* @__PURE__ */ l("path", { fill: "#0364B8", d: "M16.28 18.395h5.58v5.024h-5.58z" }),
        /* @__PURE__ */ l("path", { fill: "#14447D", d: "M10.822 18.437h5.457v4.547h-5.457z" }),
        /* @__PURE__ */ l("path", { fill: "#0078D4", d: "M21.86 18.395h5.024v5.024H21.86z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "url(#outlook-colored_svg__b)",
            d: "m27.744 17.158-.01.006-8.317 4.677a1.16 1.16 0 0 1-.563.174l-.453-.266a1 1 0 0 1-.112-.064l-8.428-4.81h-.004l-.276-.154v9.468c.005.632.52 1.14 1.152 1.137h16.133c.01 0 .018-.005.028-.005q.202-.013.39-.081.083-.034.158-.082c.037-.021.101-.067.101-.067.286-.212.456-.546.457-.902v-9.468a.5.5 0 0 1-.256.437"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#0A2767",
            d: "M27.553 16.684v.58l-8.695 5.987-9.003-6.372a.01.01 0 0 0-.006-.006l-.826-.496v-.419l.34-.006.72.413.017.006.062.04s8.461 4.827 8.483 4.838l.324.19.09-.034 8.4-4.727z",
            opacity: 0.5
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#1490DF",
            d: "m27.744 17.158-.01.006-8.317 4.677a1.166 1.166 0 0 1-1.247 0l-8.316-4.677-.01-.006a.5.5 0 0 1-.263-.437v9.468c.004.632.52 1.14 1.151 1.137H26.85a1.144 1.144 0 0 0 1.15-1.137v-9.468a.5.5 0 0 1-.255.437"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "m19.539 21.772-.125.07a1.156 1.156 0 0 1-.55.18l3.164 3.74 5.52 1.33c.15-.113.27-.264.35-.436z",
            opacity: 0.1
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "m20.102 21.455-.688.387a1.156 1.156 0 0 1-.55.18l1.482 4.086 7.203.983c.284-.213.45-.547.45-.902v-.122z",
            opacity: 0.05
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#28A8EA",
            d: "M10.748 27.326h16.1c.247 0 .489-.077.689-.224L18.4 21.75a1 1 0 0 1-.112-.064l-8.428-4.81h-.004l-.275-.155v9.436c0 .645.522 1.168 1.167 1.169"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "M17.395 10.488v11.905a1.03 1.03 0 0 1-.642.95 1 1 0 0 1-.38.077H9.582V10.023h1.117v-.558h5.676c.564.002 1.02.46 1.021 1.023",
            opacity: 0.1
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "M16.837 11.046v11.905a.9.9 0 0 1-.084.391 1.02 1.02 0 0 1-.937.635H9.58V10.023h6.235a.94.94 0 0 1 .463.117c.342.173.558.523.558.906",
            opacity: 0.2
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "M16.837 11.046v10.79a1.03 1.03 0 0 1-1.021 1.024H9.58V10.023h6.235a.94.94 0 0 1 .463.117c.342.173.558.523.558.906",
            opacity: 0.2
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "M16.279 11.046v10.79c0 .564-.457 1.022-1.021 1.024H9.58V10.023h5.677c.564 0 1.021.458 1.021 1.023",
            opacity: 0.2
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "url(#outlook-colored_svg__c)",
            d: "M5.023 10.023h10.233c.565 0 1.023.458 1.023 1.023V21.28c0 .565-.458 1.023-1.023 1.023H5.023A1.023 1.023 0 0 1 4 21.28V11.046c0-.565.458-1.023 1.023-1.023"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "M7.198 14.314c.252-.537.659-.986 1.168-1.29a3.53 3.53 0 0 1 1.857-.466 3.3 3.3 0 0 1 1.719.441c.49.293.885.721 1.137 1.234.274.565.41 1.186.398 1.814a4.2 4.2 0 0 1-.41 1.897c-.258.531-.665.975-1.172 1.277a3.4 3.4 0 0 1-1.783.453 3.36 3.36 0 0 1-1.756-.446 3 3 0 0 1-1.152-1.236A3.9 3.9 0 0 1 6.8 16.2a4.3 4.3 0 0 1 .397-1.886m1.245 3.031c.135.34.363.634.658.85.3.21.66.318 1.027.309.39.015.775-.097 1.096-.32a1.85 1.85 0 0 0 .639-.849c.14-.38.209-.78.203-1.185a3.6 3.6 0 0 0-.192-1.2 1.9 1.9 0 0 0-.618-.885 1.7 1.7 0 0 0-1.087-.335c-.374-.01-.742.1-1.05.312-.301.216-.533.513-.67.857a3.4 3.4 0 0 0-.005 2.447z"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#50D9FF", d: "M21.86 8.349h5.024v5.023H21.86z" })
      ] }),
      /* @__PURE__ */ o("defs", { children: [
        /* @__PURE__ */ o(
          "linearGradient",
          {
            id: "outlook-colored_svg__b",
            x1: 18.791,
            x2: 18.791,
            y1: 16.721,
            y2: 27.326,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { stopColor: "#35B8F1" }),
              /* @__PURE__ */ l("stop", { offset: 1, stopColor: "#28A8EA" })
            ]
          }
        ),
        /* @__PURE__ */ o(
          "linearGradient",
          {
            id: "outlook-colored_svg__c",
            x1: 6.133,
            x2: 14.146,
            y1: 9.224,
            y2: 23.102,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ l("stop", { stopColor: "#1784D9" }),
              /* @__PURE__ */ l("stop", { offset: 0.5, stopColor: "#107AD5" }),
              /* @__PURE__ */ l("stop", { offset: 1, stopColor: "#0A63C9" })
            ]
          }
        ),
        /* @__PURE__ */ l("clipPath", { id: "outlook-colored_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M4 5h24v22.326H4z" }) })
      ] })
    ]
  }
);
export {
  c as default
};
